import axios from "axios";

const instance = axios.create();

if (process.env.NODE_ENV == "production") {
  instance.defaults.baseURL = "https://halo.rcsd.ca/rest";
} else {
  instance.defaults.baseURL = "http://localhost:1337";
}

export default instance;
